import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-transaction',
  templateUrl: './general-transaction.component.html',
  styleUrls: ['./general-transaction.component.css']
})
export class GeneralTransactionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/general-transaction/general-transaction.component.ts